<template>
    <div class="launch-page">
        <!-- banner -->
        <banner-sections></banner-sections>

        <!-- launch-an-event -->
        <div class="cnt-section our-section">
            <div class="container p-l-30 p-r-30">
                <div class="row">
                    <h4 class="col-12 section-title">How to launch an event</h4>
                </div>
                <div class="row row-deck">
                    <div class="col-xl-4 col-lg-6" v-for="(event, index) in launchEventList" :key="index">
                        <div class="service-box">
                            <div class="service-icon">{{ index + 1 }}</div>
                            <div class="service-cnt">
                                <p>{{ event.name }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- description -->
        <description-sections></description-sections>

        <!-- join-the-community-->
        <join-community></join-community>

    </div>
</template>
<script>
export default {
    name: "LaunchEventMainComponent",
    components: {
        'banner-sections': () => import("@/components/frontend/launch-event/EventBanner.vue"),
        'description-sections': () => import("@/components/frontend/launch-event/EventDescription.vue"),
        'join-community': () => import("@/components/core/JoinCommunity.vue"),
    }, data() {
        return {
            launchEventList: [
                {
                    name: 'Create an account',
                    url: ''
                },
                {
                    name: 'Create an event by providing the event details',
                    url: ''
                },
                {
                    name: 'Setup your ticketing options',
                    url: ''
                },
                {
                    name: 'Utilize discount codes per your desire',
                    url: ''
                },
                {
                    name: `Customize your attendee's registration form`,
                    url: ''
                },
                {
                    name: 'Preview and Launch',
                    url: ''
                }
            ]
        }
    }
}
</script>
<style>
.page-loader-wrapper {
    display: none;
}
</style>